export const domains = {
	Allianz: ["allianz.uprise.co", "dev-allianz-app.uprise.co"]
}
